export default {
  'bandWidth.topTitle': 'Bandwidth report',
  'bandWidth.name': 'Bandwidth',
  'bandWidth.topTitle.text': '(Please view the data according to utc+8.)',
  'bandWidth.menu.text1': 'Edge locations',
  'bandWidth.menu.text2': 'Continents',
  'bandWidth.menu.text3': 'CDN Resources',
  'bandWidth.oneColumns.title2': 'Bandwidth',
};
